import Matter from 'matter-js'
import { assets, matterAssets, dataAnalysis, testIndex, linesNum } from './gameUI.js'
import { settings } from '../settings.js'
import { playLeftDropSound, playRightDropSound, playSoundForBoxDrop } from '../soundManager.js'
import { dispatchEveryBallTouch, dispatching } from '../bridge.js'
import { path } from './ball.js'
// import { addMultiplier } from 'games/PlinkoGame/slice-thunk/plinkoGame.slice.js'
// import store from 'redux-store/store.js'

let boxInd
export const setupMatterJS = () => {
  if (!matterAssets.engine) {
    matterAssets.engine = Matter.Engine.create()
  }
  matterAssets.world = matterAssets.engine.world
  if (!matterAssets.world) {
    matterAssets.world = matterAssets.engine.world
  }
  matterAssets.engine.timing.isFixed = true
  matterAssets.engine.timing.fixedDeltaTime = 16.67 // 60 FPS (in milliseconds)

  if (matterAssets.world) {
    matterAssets.world.gravity.y = settings.matter.gravity
  }

  Matter.Events.off(matterAssets.engine, 'collisionStart')
  Matter.Events.on(matterAssets.engine, 'collisionStart', event => {
    let box
    event.pairs.forEach(pair => {
      const { bodyA, bodyB } = pair

      if ((bodyA.label === 'Ball' && bodyB.label === 'Point') || (bodyA.label === 'Point' && bodyB.label === 'Ball')) {
        const pointBody = bodyA.label === 'Point' ? bodyA.parent : bodyB.parent
        if (pointBody) {
          assets.points?.[pointBody.pointRow]?.[pointBody.pointNumber]?.pixiBody?.startShine?.()
        }

        const ballBody = bodyA.label === 'Ball' ? bodyA.parent : bodyB.parent
        if (ballBody) {
          path(ballBody, pointBody)
          if (ballBody.position.x > ballBody.prevPointX) playRightDropSound()
          else playLeftDropSound()

          ballBody.prevPointX = ballBody.position.x
        }
      }
      let fault = false
      if ((bodyA.label === 'Ball' && bodyB.label === 'Box') || (bodyA.label === 'Box' && bodyB.label === 'Ball')) {
        const boxBody = bodyA.label === 'Box' ? bodyA.parent : bodyB.parent
        if (boxBody) {
          playSoundForBoxDrop(boxBody.boxIndex, linesNum.get() + 1)
          box = assets.boxes[boxBody.boxIndex]?.boxContainer
          if (box) {
            box.y = box.startPos + 40
            box.boxState = box.boxBounceEffect
            boxInd = assets.boxes[boxBody.boxIndex]?.boxMatter?.boxIndex
            if (assets.boxes[boxBody.boxIndex]?.boxMatter?.boxIndex !== testIndex) {
              fault = true
            }
          } else console.error('Box not identified')
        }

        const ballBody = bodyA.label === 'Ball' ? bodyA.parent : bodyB.parent
        if (ballBody) {
          const ballObject = assets.activeBalls.find(ball => ball.matterBody === ballBody)
          if (ballObject && typeof ballObject.destroy === 'function') {
            if (dataAnalysis?.[linesNum.get() - settings.lines.initialNumber]?.[boxInd]) {
              dataAnalysis[linesNum.get() - settings.lines.initialNumber][boxInd].push(ballBody.initialX)
            }
            boxInd = null
            if (fault) {
              fault = false
            }
            ballObject.destroy()
            dispatchEveryBallTouch()
            if (assets.activeBalls.length - 1 < 0) dispatching()
          }
        }
      }
    })
  })
}

let matterRunner = null

export const matterEngineIgnition = () => {
  if (!matterRunner && matterAssets.engine) {
    matterRunner = Matter.Runner.create()
    Matter.Runner.run(matterRunner, matterAssets.engine)
  }
}

export const destroyMatterWorld = () => new Promise((resolve, reject) => {
  if (matterRunner) {
    Matter.Runner.stop(matterRunner)
    matterRunner = null
  }
  if (matterAssets.engine) {
    Matter.Events.off(matterAssets.engine, 'collisionStart')
  }
  if (matterAssets.world) {
    Matter.World.clear(matterAssets.world, true)
    matterAssets.world = null
  }
  if (matterAssets.engine) {
    Matter.Engine.clear(matterAssets.engine)
    matterAssets.engine = null
  }
  resolve()
})
